export let PredictionsActionsTypes;
(function (PredictionsActionsTypes) {
  PredictionsActionsTypes["SetCompanyInfoPrediction"] = "SET_COMPANY_INFO_PREDICTION";
})(PredictionsActionsTypes || (PredictionsActionsTypes = {}));